export const calculateConsomQuantities = (stayRows) => {
    let quantiteConsom = 0;


        for (let i = 0; i < stayRows.length; i++) {
            const { pax, quantite } = stayRows[i];
                quantiteConsom += quantite * pax;
        }


    return { quantiteConsom};
};



export const updatePaymentRowsQuantities = (stayRows, paymentRows, setPaymentRows) => {
    const updatedPaymentRows = [...paymentRows];
    const { quantiteConsom } = calculateConsomQuantities(stayRows);
    if (Array.isArray(updatedPaymentRows) && updatedPaymentRows.length > 0) {
        for (let i = 0; i < updatedPaymentRows.length; i++) {
            const description = updatedPaymentRows[i].description;
            console.log("description",description);
            if (description === 'مشروبات' || description === 'عشاء' || description === 'غداء' || description === 'وجبات مصحوبة بالمشروبات') {
                updatedPaymentRows[i].quantiteConsom = quantiteConsom;
                console.log("quantiteConsom",updatedPaymentRows[i].quantiteConsom);
            } else if (description === 'غسيل') {
                updatedPaymentRows[i].quantiteConsom = 1;
            }
        }
    }
    setPaymentRows([...updatedPaymentRows]);
};
